import instance from "../Config/Config";


export const DIGITAL_SCHEME_PLAN = "get_digital_plan"
export const DIGITAL_PLAN_PURCHASE = "digital_plan_purchase"
export const DIGITAL_TRANSACTION = "get_digital_transaction"
export const PLAN_ACTIVE = "plan_active"
export const DAILY_PAY_SCHEME = "pay_digital_plan"
export const CANCEL_SCHEME_URL = "digital_plan_cancel"
export const PLAN_BENEFIT_URL = "digital_plan_benifits"

//for silver plan
export const DIGITAL_SILVER_PLAN_PURCHASE = "digital_silver_plan_purchase"
export const SILVER_PLAN_ACTIVE = "silver_plan_active"
export const DAILY_PAY_SILVER_SCHEME = "pay_digital_silver_plan"
export const SILVER_CANCEL_SCHEME_URL = "digital_silver_plan_cancel"
export const SILVER_PLAN_BENEFIT_URL = "digital_silver_plan_benifits"
export const DIGITAL_SILVER_TRANSACTION = "get_digital_silver_transaction"
export const CANCEL_SILVER_SCHEME = "digital_silver_plan_cancel"


export const Digitalscheme_fun = async()=>{
       const response = await instance.get(`${DIGITAL_SCHEME_PLAN}`)
       return response?.data
}

export const Savedigitalplan = async(value)=>{
       const response = await instance.post(`${DIGITAL_PLAN_PURCHASE}`,value)
       return response?.data
}



export const Getdigital_trans = async(slug)=>{
       const response = await instance.get(`${DIGITAL_TRANSACTION}?plan_status=${slug}`)
       return response?.data
}

export const Post_PlanActive = async(id)=>{
       const body = {
              "purchase_id " : id
       }
       const response = await instance.post(`${PLAN_ACTIVE}`,body)
       return response?.data
}

//silver plan active

export const Getdigital_silver_trans = async(slug)=>{
       const response = await instance.get(`${DIGITAL_SILVER_TRANSACTION}?plan_status=${slug}`)
       return response?.data
}


export const Post_Silver_PlanActive = async(id)=>{
       const body = {
              "purchase_id " : id
       }
       const response = await instance.post(`${SILVER_PLAN_ACTIVE}`,body)
       return response?.data
}

export const SavedigitalSilverplan = async(value)=>{
       const response = await instance.post(`${DIGITAL_SILVER_PLAN_PURCHASE}`,value)
       return response?.data
}

export const PayDaily_Silver_Scheme = async(value)=>{
       const response = await instance.post(`${DAILY_PAY_SILVER_SCHEME}`,value)
       return response?.data
}

export const Cancel_Silver_scheme = async(id)=>{
       const response = await instance.post(`${CANCEL_SILVER_SCHEME}?purchase_id=${id}`)
       return response?.data
}


//

export const PayDaily_Scheme = async(value)=>{
       const response = await instance.post(`${DAILY_PAY_SCHEME}`,value)
       return response?.data
}

export const Cancel_scheme = async(id)=>{
       const response = await instance.post(`${CANCEL_SCHEME_URL}?purchase_id=${id}`)
       return response?.data
}

export const GetPlanbenefit = async()=>{
       const response = await instance.get(`${PLAN_BENEFIT_URL}`)
       return response?.data
}